import React from "react";
import Chip from "@mui/material/Chip";
import { PaymentStatus } from "../../../../../hooks/useNepalPayWSS";

interface PaymentStatusChipProps {
  status: PaymentStatus;
}

const statusMap: Record<
  Exclude<PaymentStatus, null>,
  {
    label: string;
    color: "default" | "primary" | "success" | "error" | "warning" | "info" | "secondary";
  }
> = {
  ENTR: { label: "Processing", color: "warning" },
  PARSED: { label: "QR Scanned", color: "info" },
  COMPLETED: { label: "Completed", color: "success" },
  FAILED: { label: "Failed", color: "error" }
};

const PaymentStatusChip: React.FC<PaymentStatusChipProps> = ({ status }) => {
  if (!status) return null;

  const { label, color } = statusMap[status];
  return <Chip label={label} color={color} size="small" />;
};

export default PaymentStatusChip;
